const fmtTs = (ts) => {
  if (!ts?.toDate) return '';
  return ts.toDate().toISOString();
};

const escapeCell = (val) => {
  const s = val == null ? '' : String(val);
  if (s.includes(',') || s.includes('"') || s.includes('\n')) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
};

export const ordersToCsv = (orders) => {
  const headers = [
    'orderNumber', 'orderDate', 'orderId', 'shopName', 'customerName', 'customerPhone', 'subtotal', 'deliveryFee',
    'total', 'paymentMode', 'paymentStatus', 'status', 'cancellationReason',
    'deliveryPartnerName', 'createdAt',
  ];
  const rows = orders.map((o) => [
    o.orderNumber ?? '',
    o.orderDate || '',
    o.id,
    o.shopName || '',
    o.customerName || '',
    o.customerPhone || '',
    o.subtotal ?? '',
    o.deliveryFee ?? '',
    o.total ?? '',
    o.paymentMode || 'cash',
    o.paymentStatus || '',
    o.status || '',
    o.cancellationReason || '',
    o.deliveryPartnerName || '',
    fmtTs(o.createdAt),
  ]);
  return [headers.join(','), ...rows.map((r) => r.map(escapeCell).join(','))].join('\n');
};

export const downloadCsv = (csv, filename) => {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};

export const exportOrdersCsv = (orders, filename = 'orders.csv') => {
  downloadCsv(ordersToCsv(orders), filename);
};
